<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
     <!-- <NavigationBar @updateChildComponent="updateChildComponent"></NavigationBar> -->
    <router-view :key="$route.fullPath+1"></router-view>

  </div>
</template>

<script>
// import NavigationBar from './components/NavigationBar.vue'

export default {
  name: 'App',
  components: {
    // NavigationBar
  },
}
</script>

<style>

/* 简单版 CSS Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
}

body {
  font-size: 16px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}

input, button, textarea, select {
  font: inherit;
}

p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

i {
  font-style: normal; /* 去除斜体 */
}
</style>
